import { AppState } from "../meta-reducer/index";
import { Store, select } from "@ngrx/store";
import { filter, map, mergeMap, withLatestFrom, catchError } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AccountApiService } from "../../providers/api.service";
import { isUserBudgetLoaded } from "./newfeed.selectors";
import * as NewsFeedActions from "./newsfeed.actions";
import { of } from "rxjs";
@Injectable()
export class NewFeedEffects {
  constructor(
    private actions$: Actions,
    private _accountApiService: AccountApiService,
    private store: Store<AppState>,
  ) {}

  loadBudgets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NewsFeedActions.userBudgetRequested),
      withLatestFrom(this.store.pipe(select(isUserBudgetLoaded))),
      filter(([action, isUserBudgetLoaded]) => !isUserBudgetLoaded),
      mergeMap((action) =>
        this._accountApiService.getUserBudget().pipe(
          catchError((error) => {
            this.store.dispatch(NewsFeedActions.userBudgetLoadingError({ errorMessage: error.message }));
            return of([]);
          }),
        ),
      ),
      map((budget) =>
        NewsFeedActions.userBudgetLoaded({
          userBudget: budget?.data,
          isLoaded: true,
          lastRewardReceivedByUserName: "",
          lastRewardSentDaysAgo: 0,
        }),
      ),
    ),
  );

  resetBudgets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NewsFeedActions.userBudgetResetRequested),
      mergeMap((action) => this._accountApiService.getUserBudget()),
      map((budget) => NewsFeedActions.userBudgetResetCompleted({ userBudget: budget?.data })),
    ),
  );
}
